import { ITabConfig } from '@app/core/interfaces/tab.interface';

export const STOCK_TAB_ACTIVE = {
  path: 'active',
  label: 'Active Stock',
} as const satisfies ITabConfig;

export const STOCK_TAB_SHIPPED = {
  path: 'shipped',
  label: 'Shipped Stock',
} as const satisfies ITabConfig;

export const STOCK_TABS_CONFIG: ITabConfig[] = [
  STOCK_TAB_ACTIVE,
  STOCK_TAB_SHIPPED,
];

export const STOCK_DEFAULT_TAB = STOCK_TAB_ACTIVE.path;
export const STOCK_BASE_PATH = '/account/stock' as const;
export const STOCK_FEATURE_KEY = 'stock' as const;

/** Query param used by pallet-data-change notifications to deep-link into stock search by pallet number */
export const STOCK_PALLET_NUMBERS_QUERY_PARAM = 'palletNumbers' as const;
